/* Barclay Archive — drop countdowns. Pairs with snippets/barclay-drop.liquid.
   Every [data-bd-at] node gets a live D/H/M/S countdown in the visitor's own timezone. */
(function () {
  'use strict';
  var TICK = 1000;
  var nodes = [];
  var dtf = null, dtfShort = null;
  try {
    dtf = new Intl.DateTimeFormat(undefined, {
      weekday: 'short', day: 'numeric', month: 'short',
      hour: 'numeric', minute: '2-digit', timeZoneName: 'short'
    });
    dtfShort = new Intl.DateTimeFormat(undefined, { day: 'numeric', month: 'short' });
  } catch (e) { dtf = null; dtfShort = null; }

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function setUnit(node, unit, value) {
    var el = node.querySelector('[data-bd-unit="' + unit + '"]');
    if (el && el.textContent !== value) el.textContent = value;
  }

  function register(node) {
    if (node.__bd) return;
    node.__bd = true;
    var raw = node.getAttribute('data-bd-at') || '';
    var t = raw ? Date.parse(raw) : NaN;
    if (isNaN(t)) { node.classList.add('bd--nodate'); return; }
    node.__bdT = t;
    var dateEl = node.querySelector('[data-bd-date]');
    if (dateEl) {
      var f = node.classList.contains('bd--card') ? dtfShort : dtf;
      if (f) dateEl.textContent = f.format(new Date(t));
    }
    nodes.push(node);
    paint(node, Date.now());
  }

  function paint(node, now) {
    var diff = node.__bdT - now;
    if (diff <= 0) { node.classList.add('bd--live'); return; }
    var s = Math.floor(diff / 1000);
    setUnit(node, 'd', String(Math.floor(s / 86400)));
    setUnit(node, 'h', pad(Math.floor((s % 86400) / 3600)));
    setUnit(node, 'm', pad(Math.floor((s % 3600) / 60)));
    setUnit(node, 's', pad(s % 60));
  }

  function scan(root) {
    var list = (root || document).querySelectorAll('[data-bd-at]');
    for (var i = 0; i < list.length; i++) register(list[i]);
  }

  function tick() {
    var now = Date.now();
    for (var i = 0; i < nodes.length; i++) if (nodes[i].__bdT) paint(nodes[i], now);
  }

  function markPage() {
    var info = document.querySelector('.bd--info[data-bd-scope]');
    if (!info) return;
    var state = info.getAttribute('data-bd-scope');
    document.body.classList.add('bd-page-' + state);
    /* the theme's disabled "Sold out" buttons become the drop promise */
    var label = state === 'coming' ? 'Coming soon' : 'Back soon';
    var btns = document.querySelectorAll('button[name="add"][disabled], .product-form__submit[disabled]');
    for (var i = 0; i < btns.length; i++) {
      var span = btns[i].querySelector('span:not(.visually-hidden)') || btns[i];
      if (/sold\s*out/i.test(span.textContent)) span.textContent = label;
    }
  }

  /* Notify modal copy: a hidden design is "first to know", a restock is "back in stock" */
  document.addEventListener('click', function (e) {
    var trigger = e.target && e.target.closest ? e.target.closest('.nm-trigger, [data-notify-me], .product-card__notify') : null;
    if (!trigger) return;
    var coming = trigger.closest('.is-drop-coming') || document.body.classList.contains('bd-page-coming');
    var sub = document.querySelector('#nm-modal .nm-modal__sub');
    if (sub) {
      sub.textContent = coming
        ? 'This one is still under wraps. Leave your details and you will be first to know the moment it drops.'
        : 'Get a notification as soon as this product is back in stock.';
    }
  }, true);

  function init() {
    scan(document);
    markPage();
    setInterval(tick, TICK);
    if ('MutationObserver' in window) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType !== 1) continue;
            if (n.hasAttribute && n.hasAttribute('data-bd-at')) register(n);
            else if (n.querySelectorAll) scan(n);
          }
        }
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  /* A card's "Notify me" links to <product>?notify=1. STOQ renders its own button on the product
     page a moment after load, so wait for it, click it once, and tidy the URL.
     ⛔ Drive STOQ's real button, never window._RestockRocket.openModal(e,t,r) — that is minified
        internals with an undocumented signature and it breaks on their releases. */
  function openNotifyFormIfAsked() {
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
    if (params.get('notify') !== '1') return;

    var SELECTOR = '.restock-rocket-button-product, .restock-rocket-button';
    var waited = 0, STEP = 150, LIMIT = 15000, done = false;

    function strip() {
      try {
        params.delete('notify');
        var q = params.toString();
        window.history.replaceState({}, '', window.location.pathname + (q ? '?' + q : '') + window.location.hash);
      } catch (e) {}
    }

    (function poll() {
      if (done) return;
      var btn = document.querySelector(SELECTOR);
      if (btn && btn.offsetParent !== null) {
        done = true;
        strip();
        btn.click();
        return;
      }
      waited += STEP;
      if (waited >= LIMIT) { done = true; strip(); return; }   /* give up quietly, leave the page usable */
      setTimeout(poll, STEP);
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); openNotifyFormIfAsked(); });
  } else { init(); openNotifyFormIfAsked(); }
})();
